import { getCountryFromCountryName } from '@appchoose/address';
import { isPast } from 'date-fns';

import type { Brand } from '../stores/brand';
import { StoreRegion } from '../types/generated';
import type { BillingQuery } from '../types/generated-new';
import { isInUE } from './utils';

export const hasMissingBillingInformations = (brand: Brand) => {
  return (
    !brand?.billing_address ||
    (brand?.store === StoreRegion.Fr &&
      isInUE(getCountryFromCountryName(brand.billing_address.country)?.code) &&
      !brand.intracommunity_vat &&
      !brand.is_autoentrepreneur)
  );
};

export const hasBillingErrors = (
  billingError: unknown,
  billing: BillingQuery['billingV2'] | undefined
) => {
  // eslint-disable-next-line no-constant-binary-expression
  return billingError ?? billing === null ?? billing?.has_error;
};

export const hasSaleStarted = (startDate?: string) => {
  if (!startDate) return false;

  return isPast(new Date(startDate));
};

export const hasSaleEnded = (endDate?: string) => {
  if (!endDate) return false;

  return isPast(new Date(endDate));
};
